module.exports = __webpack_public_path__ + "img/ic_logo.a8f9878f.png";